import { Component, Input, OnInit } from '@angular/core';
import { Roles, StudioSidebarItem } from '@sc/types';

import { StudioSidebarService } from '../../services/studio-sidebar/studio-sidebar.service';
import { SessionsService } from '../../services/sessions/sessions.service';
@Component({
  selector: 'sc-studio-sidebar',
  templateUrl: './studio-sidebar.component.html',
  styleUrls: ['./studio-sidebar.component.scss'],
})
export class StudioSidebarComponent {
  @Input() sidebar: StudioSidebarItem;
  @Input() sidebarIndex: number;
  session$ = this.sessionsService.studioSession$;

  constructor(private studioSidebarService: StudioSidebarService, private sessionsService: SessionsService) {}

  closeSidebar() {
    this.studioSidebarService.toggleSidebar(undefined, false, this.sidebarIndex);
  }
}
